<!-- Sign in to Firebase First -------------------------------------------------------------------------->
<div class="cpcontent googlesignin" [hidden]="isAuthenticatedWithFirebase">
    <h5>Signin with Google to access the Firebase database</h5>
    <br>
    <div class="row">
        <div class="col-md-6">
            <button class="btn btn-primary" (click)="signInWithGoogle()">Sign in with Google</button>
        </div>
    </div>
</div>

<div class="cpcontent" [hidden]="!isAuthenticatedWithFirebase">
    <h1>Worlds in Firebase Database</h1>
    <!-- Select World and other header -------------------------------------------------------------------------->
    <div class="row">
        <div class="col-md-4">
            <div style="display:inline-block;max-width:200px"><sa-select [(Id)]="worldkey" [title]="'Worlds'" [options]="worldskeys"></sa-select></div>
            <button class="btn btn-primary" (click)="selectWorld()" style="margin-left:20px">Select World</button>

            <br><br>
            <b>Add a new world by copying from an existing one.</b><br>
            The new name has to be unique.<br>
            <div style="display:inline-block;max-width:200px"><sa-select [(Id)]="worldkey" [title]="'Worlds'" [options]="worldskeys"></sa-select></div>
            <button class="btn btn-primary" (click)="addWorld()" style="margin-left:20px">Copy World to</button>
            <div style="display:inline-block;max-width:200px;margin-left:20px">
                <sa-input-text [(text)]="newWorldName" [title]="'new name' "></sa-input-text>
            </div>
            <br>
        </div>
        <div class="col-md-8">
            <div>
                <canvas id="canvas" #canvas width="100" height="100" style="border: 1px solid #000;" (click)="plotObjects()"></canvas>
                <br>
                Rough outline of position of components
            </div>
        </div>
    </div>
    <br>
    <div *ngIf="showTabs">
        <div style="font-weight:bold">Selected World: {{worldname}}</div>
        <br>
        <!-- Tabs -------------------------------------------------------------------------->
        <div class="container">
            <ul class="nav nav-tabs" id="myTab2" role="tablist">
                <li class="nav-item" role="presentation">
                    <a class="nav-link active" id="components-tab" data-bs-toggle="tab" href="#header" role="tab" aria-controls="header" aria-selected="true">Header</a>
                </li>
                <li class="nav-item" role="presentation">
                    <a class="nav-link" id="components-tab" data-bs-toggle="tab" href="#components" role="tab" aria-controls="component" aria-selected="true">Components</a>
                </li>
                <li class="nav-item" role="presentation">
                    <a class="nav-link" id="skybox-tab" data-bs-toggle="tab" href="#skybox" role="tab" aria-controls="clone" aria-selected="false">
                        Skybox
                    </a>
                </li>
                <li class="nav-item" role="presentation">
                    <a class="nav-link" id="walls-tab" data-bs-toggle="tab" href="#walls" role="tab" aria-controls="clone" aria-selected="false">
                        Walls
                    </a>
                </li>
                <li class="nav-item" role="presentation">
                    <a class="nav-link" id="ground-tab" data-bs-toggle="tab" href="#ground" role="tab" aria-controls="clone" aria-selected="false">
                        Ground
                    </a>
                </li>
                <li class="nav-item" role="presentation">
                    <a class="nav-link" id="interactivites-tab" data-bs-toggle="tab" href="#interactivites" role="tab" aria-controls="clone" aria-selected="false">
                        Interactivities
                    </a>
                </li>
                <li class="nav-item" role="presentation">
                    <a class="nav-link" id="interactivites-tab" data-bs-toggle="tab" href="#rooms" role="tab" aria-controls="clone" aria-selected="false">
                        Rooms
                    </a>
                </li>
                <li class="nav-item" role="presentation">
                    <a class="nav-link" id="json-tab" data-bs-toggle="tab" href="#json" role="tab" aria-controls="clone" aria-selected="false">
                        JSON
                    </a>
                </li>
            </ul>
        </div>


        <!-- Content of  Tabs -------------------------------------------------------------------------->
        <div class="tab-content" id="myTab2Content">
            <!-- Header -------------------------------------------------------------------------->
            <div class="tab-pane fade active show" id="header" role="tabpanel" aria-labelledby="header-tab">
                <h5>
                    Header Data
                    <i class="bi bi-question-circle" style="font-size: 1.0em;color:gray" (click)="showHeaderinfo = !showHeaderinfo"></i>
                </h5>
                <div *ngIf="showHeaderinfo" style="border:solid 1px gray; background-color: #eee;padding:10px">
                    Generic fields used to distinguish some aspects of worlds
                </div>

                <div style="max-width:250px">
                    <sa-input-boolean [(checked)]="world.isIndoorLighting" [title]="'Indoor Lighting' "></sa-input-boolean>
                    <sa-input-number [(text)]="world.lowerRadiusLimit" [title]="'camera lowerRadiusLimit' "></sa-input-number>
                    <sa-input-number [(text)]="world.upperRadiusLimit" [title]="'camera upperRadiusLimit' "></sa-input-number>
                </div>
            </div>

            <!-- Components -------------------------------------------------------------------------->
            <div class="tab-pane fade" id="components" role="tabpanel" aria-labelledby="components-tab">
                <h5 style="display:inline-block;margin-right:10px">Components for World</h5>
                <i class="bi bi-question-circle" style="font-size: 1.0em;color:gray" (click)="showComponentInfo= !showComponentInfo"></i>
                <div *ngIf="showComponentInfo" style="border:solid 1px gray; background-color: #eee;padding:10px">
                    Components define the static objects in the world.
                    In the virtual exercise a class "WorldLoader" loops through all components and loads their .glb files.
                    Each component has properties like position (in meters) and angles (in degree). The properties are edited in a modal window.
                    Special cases are handled in separate tabs in the modal window:
                    <ul>
                        <li>Clones: A component can have clones that are duplicated in the application without multiple downloads. location and rotation are relative</li>
                        <li>Sensors: The application implements a simple sensor simulator</li>
                        <li>The last part shows the whole json object of the component</li>
                    </ul>
                    The file is a json file with the following structure:
                </div>
                <button *ngIf="world != null" class="btn btn-primary" (click)="addComponent()" style="float:right">Add
                    component</button>

                <table class="table tablebordered">
                    <thead>
                        <tr>
                            <th>edit</th>
                            <th>id</th>
                            <th>Name
                                <i class="bi bi-arrow-down-up" style="font-size: 1.0em;" (click)="sortGeneric(components,'name',sortArray)"></i>
                            </th>

                            <th>File<i class="bi bi-arrow-down-up" style="font-size: 1.0em;" (click)="sortGeneric(components,'file',sortArray)"></i></th>
                            <th>Sensors?</th>
                            <th>posX<i class="bi bi-arrow-down-up" style="font-size: 1.0em;" (click)="sortGeneric(components,'posX',sortArray)"></i></th>
                            <th>posY<i class="bi bi-arrow-down-up" style="font-size: 1.0em;" (click)="sortGeneric(components,'posY',sortArray)"></i></th>
                            <th>posZ<i class="bi bi-arrow-down-up" style="font-size: 1.0em;" (click)="sortGeneric(components,'posZ',sortArray)"></i></th>
                            <th>rotX</th>
                            <th>rotY</th>
                            <th>rotZ</th>
                            <th>scale<i class="bi bi-arrow-down-up" style="font-size: 1.0em;" (click)="sortGeneric(components,'scale',sortArray)"></i></th>
                            <th>check Collisions</th>
                            <td>Clones</td>
                            <td>Special</td>
                            <th>Delete</th>

                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let c of components">
                            <td><button class="btn btn-primary btn-sm" (click)="editComponent(c)">Edit</button></td>
                            <td>{{c?.id}}</td>
                            <td>{{c?.name}}</td>
                            <td>{{c?.file}}</td>
                            <td [ngStyle]="{'background-color': c.sensors ? 'orange' : 'none'}">
                                {{(c?.sensors?.length > 0)? "Hot: " : ""}}
                            </td>
                            <td>{{c?.posX}}</td>
                            <td>{{c?.posY}}</td>
                            <td>{{c?.posZ}}</td>
                            <td>{{c?.rotX}}</td>
                            <td>{{c?.rotY}}</td>
                            <td>{{c?.rotZ}}</td>
                            <td>{{c?.scale}}</td>
                            <td>{{c?.checkCollisions}}</td>
                            <td>{{c?.clones?.length}}</td>
                            <td>{{getSpecial(c)}}</td>
                            <td><button class="btn btn-warning btn-sm" (click)="deleteComponent(c)">Delete</button></td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- Skybox -------------------------------------------------------------------------->
            <div class="tab-pane fade" id="skybox" role="tabpanel" aria-labelledby="skybox-tab">
                <h5>
                    Skybox
                    <i class="bi bi-question-circle" style="font-size: 1.0em;color:gray" (click)="showSkyboxInfo = !showSkyboxInfo"></i>
                </h5>
                <div *ngIf="showSkyboxInfo" style="border:solid 1px gray; background-color: #eee;padding:10px">
                    Skybox shows the world at the end of the horizon.
                    It is a cube with 6 images on the inside.
                    The folder containing the images is specified in the reflectionTexture property.
                    The last word if the filename followed by _px.jpg, _nx.jpg, _py.jpg, _ny.jpg, _pz.jpg, _nz.jpg.
                </div>
                <sa-input-text [(text)]="skybox.reflectionTexture" [title]="'reflectionTexture' "></sa-input-text>
                <sa-input-boolean [(checked)]="skybox.backFaceCulling" [title]="'backFaceCulling' "></sa-input-boolean>
                <sa-input-boolean [(checked)]="skybox.disableLighting" [title]="'disableLighting' "></sa-input-boolean>
                <sa-input-boolean [(checked)]="skybox.infiniteDistance" [title]="'infiniteDistance' "></sa-input-boolean>
                <sa-input-number [(text)]="skybox.size" [title]="'size' "></sa-input-number>
            </div>
            <!-- Walls -------------------------------------------------------------------------->
            <div class="tab-pane fade" id="walls" role="tabpanel" aria-labelledby="walls-tab">
                <div class="row">
                    <div class="col-md-2">
                        <h5>Walls East</h5>
                        <sa-input-text [(text)]="walls.east.diffuseTexture" [title]="'diffuseTexture' "></sa-input-text>
                        <sa-input-number [(text)]="walls.east.height" [title]="'height' "></sa-input-number>
                        <sa-input-number [(text)]="walls.east.width" [title]="'width' "></sa-input-number>
                        <sa-input-number [(text)]="walls.east.x" [title]="'x' "></sa-input-number>
                        <sa-input-number [(text)]="walls.east.y" [title]="'y' "></sa-input-number>
                        <sa-input-number [(text)]="walls.east.z" [title]="'z' "></sa-input-number>
                    </div>
                    <div class="col-md-2">
                        <h5>Walls North</h5>
                        <sa-input-text [(text)]="walls.north.diffuseTexture" [title]="'diffuseTexture' "></sa-input-text>
                        <sa-input-number [(text)]="walls.north.height" [title]="'height' "></sa-input-number>
                        <sa-input-number [(text)]="walls.north.width" [title]="'width' "></sa-input-number>
                        <sa-input-number [(text)]="walls.north.x" [title]="'x' "></sa-input-number>
                        <sa-input-number [(text)]="walls.north.y" [title]="'y' "></sa-input-number>
                        <sa-input-number [(text)]="walls.north.z" [title]="'z' "></sa-input-number>
                    </div>
                    <div class="col-md-2">
                        <h5>Walls West</h5>
                        <sa-input-text [(text)]="walls.west.diffuseTexture" [title]="'diffuseTexture' "></sa-input-text>
                        <sa-input-number [(text)]="walls.west.height" [title]="'height' "></sa-input-number>
                        <sa-input-number [(text)]="walls.west.width" [title]="'width' "></sa-input-number>
                        <sa-input-number [(text)]="walls.west.x" [title]="'x' "></sa-input-number>
                        <sa-input-number [(text)]="walls.west.y" [title]="'y' "></sa-input-number>
                        <sa-input-number [(text)]="walls.west.z" [title]="'z' "></sa-input-number>
                    </div>
                    <div class="col-md-2">
                        <h5>Walls South</h5>
                        <sa-input-text [(text)]="walls.south.diffuseTexture" [title]="'diffuseTexture' "></sa-input-text>
                        <sa-input-number [(text)]="walls.south.height" [title]="'height' "></sa-input-number>
                        <sa-input-number [(text)]="walls.south.width" [title]="'width' "></sa-input-number>
                        <sa-input-number [(text)]="walls.south.x" [title]="'x' "></sa-input-number>
                        <sa-input-number [(text)]="walls.south.y" [title]="'y' "></sa-input-number>
                        <sa-input-number [(text)]="walls.south.z" [title]="'z' "></sa-input-number>
                    </div>
                </div>
            </div>

            <!-- Ground -------------------------------------------------------------------------->
            <div class="tab-pane fade" id="ground" role="tabpanel" aria-labelledby="ground-tab">
                <h5>
                    Ground
                    <i class="bi bi-question-circle" style="font-size: 1.0em;color:gray" (click)="showGroundInfo = !showGroundInfo"></i>

                </h5>
                <div *ngIf="showGroundInfo" style="border:solid 1px gray; background-color: #eee;padding:10px">
                    The ground takes a texturemap<br>
                    Height and Width are the dimensions of the ground in meters.<br>
                    Subdivisions is the number of times the texture is repeated.<br>
                    If terrain is empty, the ground is flat; otherwise the ground elevation is defined by a heightmap.<br>
                </div>
                <sa-input-text [(text)]="ground.file" [title]="'file' "></sa-input-text>
                <div class="row">
                    <div class="col-md-4"><sa-input-number [(text)]="ground.height" [title]="'height' "></sa-input-number></div>
                    <div class="col-md-4"><sa-input-number [(text)]="ground.width" [title]="'width' "></sa-input-number></div>
                    <div class="col-md-4"><sa-input-number [(text)]="ground.subdivisions" [title]="'subdivisions' "></sa-input-number></div>
                </div>
                <div class="row">
                    <div class="col-md-4"><sa-input-boolean [(checked)]="ground.doHeightMap" [title]="'doHeightMap' "></sa-input-boolean></div>
                    <div class="col-md-4"><sa-input-text [(text)]="ground.terrain" [title]="'Terrain' "></sa-input-text></div>
                    <div class="col-md-4"><sa-input-number [(text)]="ground.maxHeight" [title]="'maxHeight' "></sa-input-number></div>
                </div>




            </div>

            <!-- Interactivity -------------------------------------------------------------------------->
            <div class="tab-pane fade" id="interactivites" role="tabpanel" aria-labelledby="ground-tab">
                <h5>
                    Interactivities
                </h5>
                Interactivies are tightly coupled to the code.<br>
                For each interactivy at loading time the app will spawn a new object associated with the code. <br>
                Variables can be part of this interactivity.<br>
                Without any interactivity in this list, no code will be triggered.<br>
                <button class="btn btn-primary" (click)="addInteractivity()">Add Interactivity</button>
                <button class="btn btn-primary" style="margin-left:50px" (click)="addSurvey()">Add Survey Interactivity</button>
                <sa-select style="display:inline-block;max-width:400px;margin-left:20px" [(Id)]="selectedLessonplanid" [title]="'Lesson plan step (needed as refernece)'" [options]="lessonplans"></sa-select>
                <br>
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th>Type</th>
                            <th>Interactivity</th>
                            <th>Index</th>
                            <th>Up</th>
                            <th>Delete</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let c of interactivities;let i = index">
                            <td>{{c.type}}</td>
                            <td class="link" (click)="openModalInter(i)">{{c | json}}</td>
                            <td>{{i}}</td>
                            <td><i class="bi bi-arrow-up" (click)="moveInteractivityUp(i)"></i></td>
                            <td><button class="btn btn-warning" (click)="deleteInteractivity(i)">delete</button></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <!-- Rooms-------------------------------------------------------------------------->
            <div class="tab-pane fade" id="rooms" role="tabpanel" aria-labelledby="ground-tab">
                <h5 style="display:inline-block">Rooms</h5>
                <button class="btn btn-primary" style="float:right" (click)="openModalRoomComponent(-1)">Add</button>
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th>Id</th>
                            <th>Copy</th>
                            <th>SeqNo</th>
                            <th>Active</th>
                            <th>Name</th>
                            <th>Type</th>
                            <th>Ref</th>
                            <th>Glb</th>
                            <th>x1</th>
                            <th>y1</th>
                            <th>x2</th>
                            <th>y2</th>
                            <th>Delete</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let c of rooms;let i = index">
                            <td class="link" (click)="openModalRoomComponent(i)">{{i}}</td>
                            <td><button class="btn btn-info" (click)="copyRoomComponent(i)">copy</button></td>
                            <td>{{c.seqNo}}</td>
                            <td>{{c.active}}</td>
                            <td class="link" (click)="openModalRoomComponent(i)">{{c.name}}</td>
                            <td>{{c.type}}</td>
                            <td>{{c.ref}}</td>
                            <td>{{c.glb}}</td>
                            <td>{{c.x1}}</td>
                            <td>{{c.y1}}</td>
                            <td>{{c.x2}}</td>
                            <td>{{c.y2}}</td>
                            <td><button class="btn btn-warning" (click)="deleteRoomComponent(i)">delete</button></td>
                        </tr>
                    </tbody>
                </table>

            </div>

            <!-- JSON -------------------------------------------------------------------------->
            <div class="tab-pane fade" id="json" role="tabpanel" aria-labelledby="json-tab">
                <h5>
                    JSON
                </h5>
                <pre>{{world | json}}</pre>>
            </div>
        </div>

        <br>
        <button class="btn btn-primary" (click)="updateWorld()">Update</button>
        <!-- <div>{{worlds | json}}</div> -->
    </div>
</div>

<!-- Modal Window ---------------------------------------------------------------------------->
<div *ngIf="showModal" #testmodal class="cpmodal">
    <div class="cpmodal-content" style="max-width:800px;margin-top:5%">
        <h5>Component "{{component.name}}"</h5>


        <div class="container mt-5">
            <ul class="nav nav-tabs" id="myTab" role="tablist">
                <li class="nav-item" role="presentation">
                    <a class="nav-link active" id="header-tab" data-bs-toggle="tab" href="#header" role="tab" aria-controls="header" aria-selected="true">Header</a>
                </li>
                <li class="nav-item" role="presentation">
                    <a class="nav-link" id="clone-tab" data-bs-toggle="tab" href="#clone" role="tab" aria-controls="clone" aria-selected="false">
                        Clone ({{component.clones? component.clones.length : 0}})
                    </a>
                </li>
                <li class="nav-item" role="presentation">
                    <a class="nav-link" id="sensor-tab" data-bs-toggle="tab" href="#sensor" role="tab" aria-controls="sensor" aria-selected="false">
                        Sensor ({{component.sensors? component.sensors.length : 0}})
                    </a>
                </li>
                <li class="nav-item" role="presentation">
                    <a class="nav-link" id="sensor-tab" data-bs-toggle="tab" href="#special" role="tab" aria-controls="sensor" aria-selected="false">
                        Special Objects
                    </a>
                </li>
                <li class="nav-item" role="presentation">
                    <a class="nav-link" id="sign-tab" data-bs-toggle="tab" href="#sign2" role="tab" aria-controls="sign2" aria-selected="false">
                        Sign
                    </a>
                </li>
                <li class="nav-item" role="presentation">
                    <a class="nav-link" id="sensor-tab" data-bs-toggle="tab" href="#raw" role="tab" aria-controls="raw" aria-selected="false">JSON</a>
                </li>
            </ul>
            <div class="tab-content" id="myTabContent">
                <div class="tab-pane fade show active" id="header" role="tabpanel" aria-labelledby="header-tab">
                    <sa-input-text [(text)]="component.name" [title]="'name'"></sa-input-text>
                    <sa-input-text [(text)]="component.file" [title]="'file'"></sa-input-text>
                    <!-- <sa-input-text [(text)]="component.file" [title]="'file' "></sa-input-text> -->
                    <div class="row">
                        <div class="col-md-4"><sa-input-number [(text)]="component.posX" [title]="'posX' "></sa-input-number></div>
                        <div class="col-md-4"><sa-input-number [(text)]="component.posY" [title]="'posY' "></sa-input-number></div>
                        <div class="col-md-4"> <sa-input-number [(text)]="component.posZ" [title]="'posZ' "></sa-input-number></div>
                    </div>
                    <div class="row">
                        <div class="col-md-4"><sa-input-number [(text)]="component.rotX" [title]="'rotX' "></sa-input-number></div>
                        <div class="col-md-4"><sa-input-number [(text)]="component.rotY" [title]="'rotY' "></sa-input-number></div>
                        <div class="col-md-4"> <sa-input-number [(text)]="component.rotZ" [title]="'rotZ' "></sa-input-number></div>
                    </div>
                    <div class="row">
                        <div class="col-md-4"> <sa-input-number [(text)]="component.scale" [title]="'scale' "></sa-input-number></div>
                        <div class="col-md-4"><sa-input-boolean [(checked)]="component.checkCollisions" [title]="'checkCollisions' "></sa-input-boolean></div>

                    </div>

                </div>
                <div class="tab-pane fade" id="clone" role="tabpanel" aria-labelledby="clone-tab">
                    <button class="btn btn-primary" (click)="addClone()">Add Clone</button>
                    <div *ngIf="component['clones'] != null">
                        <table class="table tablebordered">
                            <thead>
                                <tr>
                                    <th>posX</th>
                                    <th>posY</th>
                                    <th>posZ</th>
                                    <th>rotX</th>
                                    <th>rotY</th>
                                    <th>rotZ</th>
                                    <th>Delete</th>

                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let c of component.clones; index as i">
                                    <td><sa-input-number [(text)]="c.posX" [title]="'posX' "></sa-input-number></td>
                                    <td><sa-input-number [(text)]="c.posY" [title]="'posY' "></sa-input-number></td>
                                    <td><sa-input-number [(text)]="c.posZ" [title]="'posZ' "></sa-input-number></td>
                                    <td><sa-input-number [(text)]="c.rotX" [title]="'rotX' "></sa-input-number></td>
                                    <td><sa-input-number [(text)]="c.rotY" [title]="'rotY' "></sa-input-number></td>
                                    <td><sa-input-number [(text)]="c.rotZ" [title]="'rotZ' "></sa-input-number></td>
                                    <td><button class="btn btn-warning btn-sm" (click)="deleteClone(c,i)">Delete</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="tab-pane fade" id="sensor" role="tabpanel" aria-labelledby="sensor-tab">
                    <button class="btn btn-primary" (click)="addSensor()">Add Sensor</button>
                    <div *ngIf="component['sensors'] != null">
                        <!-- create a table equivalent to clones with columns name, units, min_distance, max_distance, max_value-->
                        <table class="table tablebordered">
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Units</th>
                                    <th>Min Distance</th>
                                    <th>Max Distance</th>
                                    <th>Max Value</th>
                                    <th>Threshold/th>
                                    <th>Delete</th>

                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let s of component.sensors">
                                    <td><sa-input-text [(text)]="s.name" [title]="'name' "></sa-input-text></td>
                                    <td><sa-input-text [(text)]="s.units" [title]="'units' "></sa-input-text></td>
                                    <td><sa-input-number [(text)]="s.min_distance" [title]="'min_distance' "></sa-input-number></td>
                                    <td><sa-input-number [(text)]="s.max_distance" [title]="'max_distance' "></sa-input-number></td>
                                    <td><sa-input-number [(text)]="s.max_value" [title]="'max_value' "></sa-input-number></td>
                                    <td><sa-input-number [(text)]="s.threshold" [title]="'Threshold' "></sa-input-number></td>
                                    <td><button class="btn btn-warning btn-sm" (click)="deleteSensor(s)">Delete</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                    </div>
                </div>
                <div class="tab-pane fade" id="special" role="tabpanel" aria-labelledby="special-tab">
                    Info: <i class="bi bi-question-circle" style="font-size: 1.0em;color:gray" (click)="showSpecialInfo = !showSpecialInfo"></i>
                    <div *ngIf="showSpecialInfo" style="border:solid 1px gray; background-color: #eee;padding:10px">
                        <h5>Fence Clones</h5>
                        The fence clones are defined by a string of characters.<br>
                        It operates like a turtle graphics system.<br>
                        "s" means to place a clone right in front of the path.<br>
                        "r" means to turn right 90 degrees.<br>
                        The width is the step width in meters.<br>
                        <h5>Video</h5>
                        The video object is a rectangle placed on the associated glb object.<br>
                        The path is the name of the video file in the assets/texture folder.<br>
                        The position and rotation are in meters and degrees and relative to the screen.glb object<br>
                        The width and height are the pixels defined by the video file (see properties in windows explorer)<br>
                        The scaling is a factor to reduce the width and height onto the screen<br>

                    </div>
                    <div class="row">
                        <div class="col-md-4">

                            <h5>
                                Fence clones
                            </h5>
                            <div *ngIf="component.cloneFence != null">

                                <sa-input-text [(text)]="component.cloneFence.path" [title]="'path' "></sa-input-text>
                                <sa-input-number [(text)]="component.cloneFence.width" [title]="'width' "></sa-input-number>
                                <br>
                                <button class="btn btn-warning" (click)="removeCloneFence(component)">Remove</button>
                            </div>
                            <div *ngIf="component.cloneFence == null">
                                <b>No Object "cloneFence"</b>
                                <button class="btn btn-primary btn-sm" (click)="createCloneFence(component)">Create object</button>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <h5>
                                Video
                            </h5>
                            <div *ngIf="component.video != null">
                                <sa-input-text [(text)]="component.video.path" [title]="'path' "></sa-input-text>
                                <sa-input-number [(text)]="component.video.posX" [title]="'posX' "></sa-input-number>
                                <sa-input-number [(text)]="component.video.posY" [title]="'posY' "></sa-input-number>
                                <sa-input-number [(text)]="component.video.posZ" [title]="'posZ' "></sa-input-number>
                                <sa-input-number [(text)]="component.video.rotX" [title]="'rotX'"></sa-input-number>
                                <sa-input-number [(text)]="component.video.rotY" [title]="'rotY' "></sa-input-number>
                                <sa-input-number [(text)]="component.video.rotZ" [title]="'rotZ' "></sa-input-number>
                                <sa-input-number [(text)]="component.video.width" [title]="'width' "></sa-input-number>
                                <sa-input-number [(text)]="component.video.height" [title]="'height' "></sa-input-number>
                                <sa-input-number [(text)]="component.video.scaling" [title]="'scaling' "></sa-input-number>
                                <br>
                                <button class="btn btn-warning" (click)="removeVideo(component)">Remove</button>
                            </div>
                            <div *ngIf="component.video == null">
                                <b>No Object "video"</b>
                                <button class="btn btn-primary btn-sm" (click)="createVideo(component)">Create object</button>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div *ngIf="component.doSmoke== null">
                                <b>No Property "doSmoke"</b>
                                <button class="btn btn-primary btn-sm" (click)="createDoSmoke(component)">Create object</button>
                            </div>
                            <div *ngIf="component.doSmoke != null">
                                <h5>
                                    Smoke
                                </h5>
                                <sa-input-number [(text)]="component.doSmoke.scaling" [title]="'scale' "></sa-input-number>
                                <br>
                                <button class="btn btn-warning" (click)="removeDoSMoke(component)">Remove</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="tab-pane fade" id="sign2" role="tabpanel" aria-labelledby="sensor-tab">
                    Info: <i class="bi bi-question-circle" style="font-size: 1.0em;color:gray" (click)="showSignInfo = !showSignInfo"></i>
                    <div *ngIf="showSignInfo" style="border:solid 1px gray; background-color: #eee;padding:10px">
                        <h5>Signs with Imagefiles</h5>
                        Use a sign mesh to put a sign onto the ground<br>
                        Use a picture file to paste onto the sign mesh<br>
                    </div>


                    <h5>Sign</h5>
                    <div *ngIf="component.sign != null">
                        <sa-input-text [(text)]="component.sign.path" [title]="'path' "></sa-input-text>
                        <div class="row">
                            <div class="col-md-4"><sa-input-number [(text)]="component.sign.posX" [title]="'posX' "></sa-input-number></div>
                            <div class="col-md-4"><sa-input-number [(text)]="component.sign.posY" [title]="'posY' "></sa-input-number></div>
                            <div class="col-md-4"><sa-input-number [(text)]="component.sign.posZ" [title]="'posZ' "></sa-input-number></div>
                        </div>
                        <div class="row">
                            <div class="col-md-4"><sa-input-number [(text)]="component.sign.rotX" [title]="'rotX' "></sa-input-number></div>
                            <div class="col-md-4"><sa-input-number [(text)]="component.sign.rotY" [title]="'rotY' "></sa-input-number></div>
                            <div class="col-md-4"><sa-input-number [(text)]="component.sign.rotZ" [title]="'rotZ' "></sa-input-number></div>
                        </div>
                        <div class="row">
                            <div class="col-md-4"><sa-input-number [(text)]="component.sign.scalingX" [title]="'scalingX' "></sa-input-number></div>
                            <div class="col-md-4"><sa-input-number [(text)]="component.sign.scalingY" [title]="'scalingY' "></sa-input-number></div>
                            <div class="col-md-4"><sa-input-number [(text)]="component.sign.scalingZ" [title]="'scalingZ' "></sa-input-number></div>
                        </div>

                        <br>
                        <button class="btn btn-warning" (click)="removeSign(component)">Remove</button>
                    </div>
                    <div *ngIf="component.sign == null">
                        <b>No Object "sign"</b>
                        <button class="btn btn-primary btn-sm" (click)="createSign(component)">Create object</button>
                    </div>


                </div>
                <div class="tab-pane fade" id="raw" role="tabpanel" aria-labelledby="sensor-tab">
                    <!-- create a scrollable div with the heght of the container -->
                    <div style="height: 300px; overflow-y: scroll; overflow-x: hidden;">
                        <pre>{{component | json }}</pre>
                    </div>
                </div>
            </div>
        </div>

        <!-- {{component | json}} -->
        <br>
        <button class="btn btn-primary" (click)="updateWorld()">Update</button>

        <button class="btn btn-primary" style="float:right" (click)="showModal = false">Close Modal</button>
    </div>
</div>

<!-- Modal General Interactivy---------------------------------------------------------------------------->
<div *ngIf="showGeneralInteractivity" #testmodal class="cpmodal">
    <div class="cpmodal-content" style="max-width:800px;margin-top:5%">
        <h5>Interactivity</h5>
        <sa-input-text [(text)]="interactivitySer" [title]="'Object'"></sa-input-text>
        <br>
        <button class="btn btn-primary" (click)="updateInteractivity()">Update</button>

        <button class="btn btn-primary" style="float:right" (click)="showGeneralInteractivity = false">Close Modal</button>
    </div>
</div>

<!-- Modal for showModal Interactivy---------------------------------------------------------------------------->
<div *ngIf="showInteractivityTypeModal" #testmodal class="cpmodal">
    <div class="cpmodal-content" style="max-width:800px;margin-top:5%">
        {{interactivity.type}}<br>
        <sa-input-text [(text)]="interactivity.name" [title]="'Name'"></sa-input-text>
        <sa-input-text [(text)]="interactivity.buttontitle" [title]="'buttontitle: text on button in lessonplan'"></sa-input-text>
        <sa-input-text [(text)]="interactivity.lessonplanid" [title]="'lessonplanid: id of div of lessonplan item in infohandler'"></sa-input-text>
        <sa-input-text [(text)]="interactivity.modalid" [title]="'modalid: id of modal in modals.html'"></sa-input-text>
        <sa-input-text [(text)]="interactivity.modalcloseid" [title]="'modalcloseid: id of modal close in modals.html'"></sa-input-text>
        {{this.interactivity | json}}
        <button class="btn btn-primary" style="float:right" (click)="showInteractivityTypeModal = false">Close Modal</button>
    </div>
</div>

<!-- Modal Survey---------------------------------------------------------------------------->
<div *ngIf="showInterctivityTypeSurvey" #testmodal class="cpmodal">
    <div class="cpmodal-content" style="max-width:800px;margin-top:5%">
        <h5>Interactivity of Type "Survey"</h5>
        <b>Make sure to select the correct lesson plan first!</b>
        <sa-select [(Id)]="selectedSurveyKey" [title]="'Survey to be used'" [options]="surveylist"></sa-select>
        <sa-select [(Id)]="selectedLPStepid" [title]="'Lesson Plan Step'" [options]="lessonplanstepoptions"></sa-select>
        <sa-input-text [(text)]="interactivity.name" [title]="'unique name of this interactivity (can be anything)'"></sa-input-text>
        <sa-input-text [(text)]="interactivity.buttontext" [title]="'Text on button in lesson plan'"></sa-input-text>
        <sa-input-number [(text)]="seqNo" [title]="'SeqNo (not really needed anymore)' "></sa-input-number>
        <br>
        <button class="btn btn-primary" (click)="updateSurveyInteractivity()">Update</button>

        <button class="btn btn-primary" style="float:right" (click)="showInterctivityTypeSurvey = false">Close Modal</button>
    </div>
</div>

<!-- Modal Room Component---------------------------------------------------------------------------->
<div *ngIf="showRoomComponent" #testmodal class="cpmodal">
    <div class="cpmodal-content" style="max-width:800px;margin-top:5%">
        <h5 style="display:inline-block;margin-right:20px">
            Room Component</h5>Id: {{roomcomponentIndex}}

        <sa-input-text [(text)]="roomcomponent.name" [title]="'Name'"></sa-input-text>
        <div class="row">
            <div class="col-md-4"> <sa-input-number [(text)]="roomcomponent.seqNo" [title]="'Sequence Number' "></sa-input-number></div>
            <div class="col-md-4"><sa-input-text [(text)]="roomcomponent.active" [title]="'Active = x'"></sa-input-text></div>
            <div class="col-md-4"><sa-input-text [(text)]="roomcomponent.type" [title]="'Type'"></sa-input-text></div>
        </div>

        <sa-input-text [(text)]="roomcomponent.ref" [title]="'Reference'"></sa-input-text>
        <sa-input-text [(text)]="roomcomponent.glb" [title]="'GLB File'"></sa-input-text>
        <div class="row">
            <div class="col-md-3"><sa-input-number [(text)]="roomcomponent.x1" [title]="'x1' "></sa-input-number></div>
            <div class="col-md-3"><sa-input-number [(text)]="roomcomponent.y1" [title]="'y1' "></sa-input-number></div>
            <div class="col-md-3"><sa-input-number [(text)]="roomcomponent.x2" [title]="'x2' "></sa-input-number></div>
            <div class="col-md-3"><sa-input-number [(text)]="roomcomponent.y2" [title]="'y2' "></sa-input-number></div>
        </div>
        <br>
        <button class="btn btn-primary" (click)="updateRoomComponent()">Update</button>

        <button class="btn btn-primary" style="float:right" (click)="showRoomComponent = false">Close Modal</button>
    </div>
</div>

<!-- Modal VehicleMovement Component---------------------------------------------------------------------------->
<div *ngIf="showVehicleMovementComponent" #testmodal class="cpmodal">
    <div class="cpmodal-content" style="max-width:1400px;margin-top:5%">
        <h5 style="display:inline-block;margin-right:20px">Vehicle Movement Component</h5>
        <button class="btn btn-primary" (click)="createVehicleMovement()">New Row</button>
        <sa-input-boolean [(checked)]="interactivity.doMove" [title]="'doMove'"></sa-input-boolean>
        <table class="table table-bordered">
            <thead>
                <tr>
                    <th>meshname</th>
                    <th>Speed [mph]</th>
                    <th>Delay [s]</th>
                    <th>doRepeat</th>
                    <th>Repeat Delay [s]</th>
                    <th>xStart</th>
                    <th>yStart</th>
                    <th>zStart</th>
                    <th>xEnd</th>
                    <th>yEnd</th>
                    <th>zEnd</th>
                    <th>Delete</th>
                </tr>
            </thead>
            <tbody>

                <tr *ngFor="let c of interactivity.vehicles;let i = index">
                    <td><sa-input-text [(text)]="c.meshname" [title]="''"></sa-input-text></td>
                    <td><sa-input-number [(text)]="c.speed" [title]="'' "></sa-input-number></td>
                    <td><sa-input-number [(text)]="c.delay" [title]="'' "></sa-input-number></td>
                    <td><sa-input-boolean [(checked)]="c.doRepeat" [title]="''"></sa-input-boolean></td>
                    <td><sa-input-number [(text)]="c.repdelay" [title]="'' "></sa-input-number></td>
                    <td><sa-input-number [(text)]="c.xStart" [title]="'' "></sa-input-number></td>
                    <td><sa-input-number [(text)]="c.yStart" [title]="'' "></sa-input-number></td>
                    <td><sa-input-number [(text)]="c.zStart" [title]="'' "></sa-input-number></td>
                    <td><sa-input-number [(text)]="c.xEnd" [title]="'' "></sa-input-number></td>
                    <td><sa-input-number [(text)]="c.yEnd" [title]="'' "></sa-input-number></td>
                    <td><sa-input-number [(text)]="c.zEnd" [title]="'' "></sa-input-number></td>
                    <td><button class="btn btn-warning" (click)="deleteVehicle(i)">delete</button></td>
                </tr>
            </tbody>
        </table>
        <button class="btn btn-primary" (click)="updateVehicleMovementComponent()">Update</button>

        <button class="btn btn-primary" style="float:right" (click)="showVehicleMovementComponent = false">Close Modal</button>
    </div>
</div>

<!-- Modal Repeater Component---------------------------------------------------------------------------->
<div *ngIf="showRepeaterComponent" #testmodal class="cpmodal">
    <div class="cpmodal-content" style="max-width:800px;margin-top:5%">
        <h5 style="display:inline-block;margin-right:20px">Repeat Component</h5>
        meshname is the name of the mesh in scene<br>
        doRepeat is a boolean to repeat the movement, used for debugging<br>
        isHorizontal is a boolean to move the mesh in horizontal direction (x,z)<br>
        length is the length of the mesh in meters<br>
        <sa-input-text [(text)]="interactivity.meshname" [title]="'meshname'"></sa-input-text>
        <div class="row">
            <div class="col-md-4"><sa-input-boolean [(checked)]="interactivity.doRepeat" [title]="'doRepeat'"></sa-input-boolean></div>
            <div class="col-md-4"><sa-input-boolean [(checked)]="interactivity.isHorizontal" [title]="'isHorizontal'"></sa-input-boolean></div>
            <div class="col-md-4"><sa-input-number [(text)]="interactivity.length" [title]="'length'"></sa-input-number></div>
        </div>

        <div class="row">
            <div class="col-md-4"><sa-input-number [(text)]="interactivity.xStart" [title]="'xStart' "></sa-input-number></div>
            <div class="col-md-4"><sa-input-number [(text)]="interactivity.yStart" [title]="'yStart' "></sa-input-number></div>
            <div class="col-md-4"><sa-input-number [(text)]="interactivity.zStart" [title]="'zStart' "></sa-input-number></div>
        </div>

        <div class="row">
            <div class="col-md-4"><sa-input-number [(text)]="interactivity.xEnd" [title]="'xEnd' "></sa-input-number></div>
            <div class="col-md-4"><sa-input-number [(text)]="interactivity.yEnd" [title]="'yEnd' "></sa-input-number></div>
            <div class="col-md-4"><sa-input-number [(text)]="interactivity.zEnd" [title]="'zEnd' "></sa-input-number></div>
        </div>
        <br>
        <button class="btn btn-primary" (click)="updateRepeatComponent()">Update</button>

        <button class="btn btn-primary" style="float:right" (click)="showRepeaterComponent = false">Close Modal</button>
    </div>
</div>

<!-- Modal triggerSensor Component---------------------------------------------------------------------------->
<div *ngIf="showtriggerSensorComponent" #testmodal class="cpmodal">
    <div class="cpmodal-content" style="max-width:1400px;margin-top:5%">
        <h5 style="display:inline-block;margin-right:20px">Trigger Sensor</h5>
        Type: {{interactivity.type }}
        <button class="btn btn-info btn-small" style="margin-left:20px" (click)="showTriggerSensorDecsription = !showTriggerSensorDecsription">Description</button>
        <br>
        <div *ngIf="showTriggerSensorDecsription">
            This interactivity manages the lead inspection trigeered readings.
            <ul>
                <li>name is the display name of the component</li>
                <li>group is used for the overall report. A student has to click only on one mesh out of the group.</li>
                <li>meshname can be found in the inspector in the exercise.</li>
                <li>isActive is used for testing and can disable the mesh</li>
            </ul>
        </div>
        <div class="row">
            <div class="col-md-4"><sa-input-text [(text)]="interactivity.name" [title]="'Name'"></sa-input-text></div>
            <div class="col-md-3"><sa-input-boolean [(checked)]="interactivity.isActive" [title]="'is active'"></sa-input-boolean></div>
            <div class="col-md-5">
                <button class="btn btn-primary" (click)="addTriggerSensorTarget()">Add</button>
                <button class="btn btn-primary" (click)="downloadAsCSV(interactivity.targets)">Download CSV</button>
                <button class="btn btn-primary" style="float:right" (click)="showtriggerSensorComponent = false">Close Modal</button>
            </div>
        </div>
        <table class="table table-bordered">
            <thead>
                <tr>
                    <th>
                        name
                        <i class="bi bi-arrow-down-up" style="font-size: 1.0em;" (click)="sortGeneric(interactivity.targets,'name',sortArray)"></i>
                    </th>
                    <th>
                        zone
                        <i class="bi bi-arrow-down-up" style="font-size: 1.0em;" (click)="sortGeneric(interactivity.targets,'zone',sortArray)"></i>
                    </th>
                    <th>
                        group
                        <i class="bi bi-arrow-down-up" style="font-size: 1.0em;" (click)="sortGeneric(interactivity.targets,'group',sortArray)"></i>
                    </th>
                    <th  style="width: 300px !important;">meshname</th>
                    <th>isActive</th>
                    <th  style="width: 100px !important;">reading</th>
                    <th>delete</th>
                </tr>
            </thead>
            <tbody>

                <tr *ngFor="let c of interactivity.targets;let i = index">
                    <td><sa-input-text [(text)]="c.name" [title]="''"></sa-input-text></td>
                    <td><sa-input-text [(text)]="c.zone" [title]="''"></sa-input-text></td>
                    <td><sa-input-text [(text)]="c.group" [title]="''"></sa-input-text></td>
                    <td><sa-input-text [(text)]="c.meshname" [title]="''"></sa-input-text></td>
                    <td><input type="checkbox" [(ngModel)]="c.isActive"></td>
                    <td><input type="number" [(ngModel)]="c.reading" placeholder="trigger" class="form-control"></td>
                    <!-- <td><sa-input-number [(text)]="c.reading" [title]="'' "></sa-input-number></td> -->
                    <td><button class="btn btn-warning" (click)="deleteTarget(i)">delete</button></td>
                </tr>
            </tbody>
        </table>
        <br>
        <button class="btn btn-primary" (click)="updateTriggerSensorComponent()">Update</button>


    </div>
</div>